require("../../scss/app-cruise-line.scss");

import TabsBehaviour from "../behaviours/tabs-behaviour";
import ShortlistCount from '../jsx/shortlist/shortlist-count';
import ShortlistButton from "../jsx/shortlist/shortlist-button";
import EmbeddedGallery from '../jsx/embedded-gallery';
import MobileMenuBehavior from "../behaviours/mobile-menu-behaviour";
import ScrollToBehaviour from "../behaviours/scroll-to-behaviour";
import ToggleClassBehavior from "../behaviours/toggle-class-behaviour";
import BackgroundImageBehaviour from "../behaviours/background-image-behaviour";
import Gallery from "../jsx/gallery";
import EqualizeBehavior from "../behaviours/equalize-behaviour";
import AccordionBehaviour from "../behaviours/accordion-behaviour";
import HideShowBehaviour   from "../behaviours/hide-show-behaviour";
import CarouselBehaviour from "../behaviours/carousel-behaviour";
import StickyNavBehaviour from "../behaviours/sticky-nav-behaviour";
import BlockEventBehaviour from "../behaviours/block-event-behaviour";
import Application from "./application";

let config = {};
config.behaviours = {
  'TabsBehaviour': new TabsBehaviour(config),
  'MobileMenuBehaviour': new MobileMenuBehavior(),
  'ScrollToBehaviour': new ScrollToBehaviour(),
  'ToggleClassBehaviour': new ToggleClassBehavior(),
  'BackgroundImageBehaviour': new BackgroundImageBehaviour(),
  'EqualizeBehavior': new EqualizeBehavior(),
  'AccordionBehaviour': new AccordionBehaviour(),
  'HideShowBehaviour': new HideShowBehaviour(),
  'CarouselBehaviour': new CarouselBehaviour(),
  'StickyNavBehaviour': new StickyNavBehaviour(),
  'BlockEventBehaviour': new BlockEventBehaviour(),
};

config.components = {
  'shortlist-count': ShortlistCount,
  'shortlist-button': ShortlistButton,
  'embedded-gallery': EmbeddedGallery,
  'gallery': Gallery,
}

new Application(config);
